import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { TariffSize, TariffStore } from '../../../../../tariff';

@Component({
    selector: 'button[app-tariff-size-button], a[app-tariff-size-button]',
    imports: [MatIconModule, NgClass],
    templateUrl: './tariff-size.button.html',
    styleUrl: './tariff-size.button.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'flex items-center w-full md:w-auto md:mx-auto text-left py-3 md:py-2 pl-7 pr-3 rounded-full border-2 border-grey md:border-secondary md:border relative mb-5 md:mb-0 md:mt-3 bg-white md:bg-transparent md:hover:bg-secondary md:hover:text-secondary-contrast',
        '[class]': 'baseClass',
        '[class.is-selected]': 'tariffSize === tariffStore.size$()',
        '[class.is-topseller]': 'tariffSize === topsellerTariff',
        '[class.is-disabled]': 'disabled',
    }
})
export class TariffSizeButton {
  public readonly baseClass = 'app-tariff-size-button';
  @Input()
  public disabled = false;

  @Input()
  public textContent?: string;

  @Input()
  public priceContent?: string;

  @Input({ required: true })
  public tariffSize: TariffSize;

  @Input()
  public topsellerText?: string;

  @Input()
  public topsellerTariff?: TariffSize;

  constructor(public tariffStore: TariffStore) {}
}
